// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-Messages-Header-__archive-button__container--2gHjA","btn":"src-components-Messages-Header-__archive-button__btn--3IkOu","disabled":"src-components-Messages-Header-__archive-button__disabled--1KKUK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Messages/Header/archive-button.css
// module id = 1959
// module chunks = 0